
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../Commonlibs/userSlice';
// import {
//   Box,
//   Grid,
//   Typography,
//   Button,
//   Pagination,
//   Card,
//   CardContent,
// } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import EditIcon from '@mui/icons-material/Edit';
// import appar from '../assets/appar.png';
// import Loader from '../Loader/Loader';

// const outfitFontStyle = {
//   fontFamily: 'Outfit, sans-serif',
// };

// const PropertySeeAll = ({ onEditProperty }) => {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [properties, setProperties] = useState([]);
//   const user = useSelector(selectUser);
//   const itemsPerPage = 6;

//   useEffect(() => {
//     const fetchProperties = async () => {
//       setLoading(true);
//       try {
//         const sellerId = user?.id || 2;
//         const response = await fetch(
//           `https://propertydealstalk.com/api/seller/getPropertiesBySellerId?seller_id=${sellerId}`
//         );
//         const data = await response.json();
        
//         if (data.status === "SUCCESS" && Array.isArray(data.result)) {
//           console.log('API Response:', data.result);
          
//           // Process the properties to ensure image URLs are correctly formatted
//           const processedProperties = data.result.map(property => {
//             const imageUrl = getPropertyImage(property);
            
//             return {
//               ...property,
//               processedImageUrl: imageUrl
//             };
//           });
          
//           setProperties(processedProperties);
//         } else {
//           console.error('Failed to fetch properties:', data);
//         }
//       } catch (error) {
//         console.error('Error fetching properties:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchProperties();
//   }, [user]);

//   // Function to get property image using the successful approach from RecommendedProperties
//   const getPropertyImage = (property) => {
//     // Check for image field first (based on the example code you shared)
//     if (property.image && property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEGoSeleaKAppYsGNby651rWv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       return `data:image/png;base64,${property.image}`;
//     }
    
//     // Then check for primary_image
//     if (property.primary_image && property.primary_image.length > 100) {
//       return `data:image/jpeg;base64,${property.primary_image}`;
//     }
    
//     // Then check for images field
//     if (property.images) {
//       // If it's a string and looks like base64
//       if (typeof property.images === 'string' && property.images.length > 100) {
//         // If it doesn't already have the data URL prefix
//         if (!property.images.startsWith('data:image')) {
//           return `data:image/jpeg;base64,${property.images}`;
//         } else {
//           return property.images;
//         }
//       }
//     }
    
//     // Fallback to default image
//     return appar;
//   };

//   const handleChangePage = (_, newPage) => setPage(newPage);
//   const pageCount = Math.ceil(properties.length / itemsPerPage);
//   const paginatedProperties = properties.slice(
//     (page - 1) * itemsPerPage,
//     page * itemsPerPage
//   );

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return null;
//     return `${currency}${Number(amount).toLocaleString()}`;
//   };

//   const getStatusClass = (status) => {
//     switch(status) {
//       case 'active':
//         return '#10b981';
//       case 'under_verification':
//         return '#f59e0b';
//       default:
//         return 'rgba(0,0,0,0.7)';
//     }
//   };

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         mt: '0px',
//         mb: { xs: '100px', md: '140px' },
//         mx: 'auto',
//         px: { xs: 2, md: 2 },
//         width: '100%',
//         maxWidth: '1100px',
//         border: '2px solid #f1f1f1',
//         borderRadius: '16px',
//         background: '#fff',
//         boxSizing: 'border-box',
//         py: { xs: 4, md: 6 },
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 4,
//           px: { xs: 1, md: 2 },
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
//         >
//           My Properties ({properties.length})
//         </Typography>
//       </Box>
      
//       {/* Custom grid layout to ensure exactly 3 cards per row */}
//       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
//         {paginatedProperties.map((property) => (
//           <Box 
//             key={property.id}
//             sx={{ 
//               width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
//               mb: 1
//             }}
//           >
//             <Card
//               sx={{
//                 borderRadius: '12px',
//                 overflow: 'hidden',
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                 height: '100%',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 position: 'relative',
//                 transition: 'all 0.3s ease',
//                 '&:hover': {
//                   boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
//                   transform: 'translateY(-2px)',
//                 },
//               }}
//             >
//               {property.status && (
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     top: 10,
//                     right: 10,
//                     backgroundColor: getStatusClass(property.status),
//                     color: 'white',
//                     padding: '4px 10px',
//                     borderRadius: '4px',
//                     fontSize: '10px',
//                     fontWeight: 500,
//                     zIndex: 1,
//                     ...outfitFontStyle,
//                   }}
//                 >
//                   {property.status === 'under_verification' ? 'Under Verification' : 
//                    property.status.charAt(0).toUpperCase() + property.status.slice(1)}
//                 </Box>
//               )}
//               <Box
//                 component="img"
//                 src={property.processedImageUrl}
//                 alt={property.property_name || "Property"}
//                 onError={(e) => {
//                   console.log(`Image error for property ${property.id}`);
//                   e.target.src = appar;
//                 }}
//                 sx={{ 
//                   width: '100%', 
//                   height: '180px', 
//                   objectFit: 'cover',
//                   backgroundColor: '#f5f5f5'
//                 }}
//               />
//               <CardContent
//                 sx={{
//                   p: 2,
//                   flexGrow: 1,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'space-between',
//                 }}
//               >
//                 <Box>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'flex-start',
//                       mb: 1,
//                       gap: 1,
//                     }}
//                   >
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         ...outfitFontStyle,
//                         fontWeight: 600,
//                         fontSize: '16px',
//                         mb: 0.5,
//                         flex: 1,
//                         lineHeight: 1.3,
//                       }}
//                     >
//                       {property.property_name || "Unnamed Property"}
//                     </Typography>
//                    <Button
//                       size="small"
//                       startIcon={<EditIcon sx={{ fontSize: 14 }} />}
//                       onClick={() => navigate(`/sell-properties/edit/${property.id}`)}
//                       sx={{
//                         minWidth: 'auto',
//                         px: 1,
//                         py: 0.5,
//                         color: '#3b82f6',
//                         fontSize: '12px',
//                         textTransform: 'none',
//                         '&:hover': {
//                           backgroundColor: 'rgba(59, 130, 246, 0.08)',
//                         },
//                         ...outfitFontStyle,
//                       }}
//                     >
//                       Edit
//                     </Button>
//                   </Box>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       ...outfitFontStyle,
//                       fontWeight: 700,
//                       color: '#3b82f6',
//                       mb: 1,
//                       fontSize: '18px',
//                     }}
//                   >
//                     {property.category === 'sale' 
//                       ? formatCurrency(property.asking_price, property.currency) 
//                       : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       ...outfitFontStyle,
//                       color: '#6b7280',
//                       fontSize: '14px',
//                       mb: 2,
//                       lineHeight: 1.4,
//                     }}
//                   >
//                     {property.area_name || ""}, {property.location || ""}
//                   </Typography>
//                 </Box>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     pt: 1,
//                     borderTop: '1px solid #f3f4f6',
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                     <VisibilityIcon
//                       sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }}
//                     />
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         ...outfitFontStyle,
//                         color: '#6b7280',
//                         fontSize: '12px',
//                         fontWeight: 500,
//                       }}
//                     >
//                       0 Views
//                     </Typography>
//                   </Box>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       ...outfitFontStyle,
//                       color: '#9ca3af',
//                       fontSize: '11px',
//                     }}
//                   >
//                     Property ID: #PD{property.id.toString().padStart(6, '0')}
//                   </Typography>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Box>
//         ))}
//       </Box>
      
//       {pageCount > 1 && (
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
//           <Pagination
//             count={pageCount}
//             page={page}
//             onChange={handleChangePage}
//             color="primary"
//             size="large"
//             sx={{
//               '& .MuiPaginationItem-root': {
//                 ...outfitFontStyle,
//                 fontWeight: 500,
//               },
//             }}
//           />
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default PropertySeeAll;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../Commonlibs/userSlice';
import {
  Box,
  Grid,
  Typography,
  Button,
  Pagination,
  Card,
  CardContent,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Loader from '../Loader/Loader';

const outfitFontStyle = {
  fontFamily: 'Outfit, sans-serif',
};

const PropertySeeAll = ({ onEditProperty }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [properties, setProperties] = useState([]);
  const user = useSelector(selectUser);

  const itemsPerPage = 6;

  useEffect(() => {
    const fetchProperties = async () => {
      setLoading(true);
      try {
        const sellerId = user?.id || 2;
        const response = await fetch(
          `https://propertydealstalk.com/api/seller/getPropertiesBySellerId?seller_id=${sellerId}`
        );
        const data = await response.json();

        if (data.status === "SUCCESS" && Array.isArray(data.result)) {
          console.log('API Response:', data.result);
          // Process the properties to check for valid images
          const processedProperties = data.result.map(property => {
            const hasImage = hasValidImage(property);
            return {
              ...property,
              hasValidImage: hasImage,
              processedImageUrl: hasImage ? getPropertyImage(property) : null
            };
          });
          setProperties(processedProperties);
        } else {
          console.error('Failed to fetch properties:', data);
        }
      } catch (error) {
        console.error('Error fetching properties:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, [user]);

  // ✅ Function to check if property has a valid image
  const hasValidImage = (property) => {
    // Check image field
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEGoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return true;
    }

    // Check primary_image field
    if (property.primary_image && property.primary_image.length > 100) {
      return true;
    }

    // Check images field
    if (property.images) {
      if (typeof property.images === 'string' && property.images.length > 100) {
        return true;
      }
    }

    return false;
  };

  // Function to get property image
  const getPropertyImage = (property) => {
    // Check for image field first
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEGoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return `data:image/png;base64,${property.image}`;
    }

    // Then check for primary_image
    if (property.primary_image && property.primary_image.length > 100) {
      return `data:image/jpeg;base64,${property.primary_image}`;
    }

    // Then check for images field
    if (property.images) {
      // If it's a string and looks like base64
      if (typeof property.images === 'string' && property.images.length > 100) {
        // If it doesn't already have the data URL prefix
        if (!property.images.startsWith('data:image')) {
          return `data:image/jpeg;base64,${property.images}`;
        } else {
          return property.images;
        }
      }
    }

    return null;
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const pageCount = Math.ceil(properties.length / itemsPerPage);
  const paginatedProperties = properties.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return null;
    return `${currency}${Number(amount).toLocaleString()}`;
  };

  const getStatusClass = (status) => {
    switch(status) {
      case 'active':
        return '#10b981';
      case 'under_verification':
        return '#f59e0b';
      default:
        return 'rgba(0,0,0,0.7)';
    }
  };

  if (loading) return <Loader />;

  return (
    <Box
      sx={{
        mt: '0px',
        mb: { xs: '100px', md: '140px' },
        mx: 'auto',
        px: { xs: 2, md: 2 },
        width: '100%',
        maxWidth: '1100px',
        border: '2px solid #f1f1f1',
        borderRadius: '16px',
        background: '#fff',
        boxSizing: 'border-box',
        py: { xs: 4, md: 6 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
          px: { xs: 1, md: 2 },
        }}
      >
        <Typography
          variant="h5"
          sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
        >
          My Properties ({properties.length})
        </Typography>
      </Box>

      {/* Custom grid layout to ensure exactly 3 cards per row */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
        {paginatedProperties.map((property) => (
          <Box
            key={property.id}
            sx={{
              width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
              mb: 1
            }}
          >
            <Card
              sx={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              {property.status && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    backgroundColor: getStatusClass(property.status),
                    color: 'white',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    fontSize: '10px',
                    fontWeight: 500,
                    zIndex: 1,
                    ...outfitFontStyle,
                  }}
                >
                  {property.status === 'under_verification' ? 'Under Verification' :
                   property.status.charAt(0).toUpperCase() + property.status.slice(1)}
                </Box>
              )}

              {/* ✅ Conditional rendering based on image availability */}
              {property.hasValidImage ? (
                <Box
                  component="img"
                  src={property.processedImageUrl}
                  alt={property.property_name || "Property"}
                  sx={{
                    width: '100%',
                    height: '180px',
                    objectFit: 'cover',
                    backgroundColor: '#f5f5f5'
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '180px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                    border: '1px dashed #ccc'
                  }}
                >
                  <Typography variant="body2" color="#888" textAlign="center" px={2}>
                    No images uploaded
                  </Typography>
                </Box>
              )}

              <CardContent
                sx={{
                  p: 2,
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      mb: 1,
                      gap: 1,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        ...outfitFontStyle,
                        fontWeight: 600,
                        fontSize: '16px',
                        mb: 0.5,
                        flex: 1,
                        lineHeight: 1.3,
                      }}
                    >
                      {property.property_name || "Unnamed Property"}
                    </Typography>
                    <Button
                      size="small"
                      startIcon={<EditIcon sx={{ fontSize: 14 }} />}
                      onClick={() => navigate(`/sell-properties/edit/${property.id}`)}
                      sx={{
                        minWidth: 'auto',
                        px: 1,
                        py: 0.5,
                        color: '#3b82f6',
                        fontSize: '12px',
                        textTransform: 'none',
                        '&:hover': {
                          backgroundColor: 'rgba(59, 130, 246, 0.08)',
                        },
                        ...outfitFontStyle,
                      }}
                    >
                      Edit
                    </Button>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      ...outfitFontStyle,
                      fontWeight: 700,
                      color: '#3b82f6',
                      mb: 1,
                      fontSize: '18px',
                    }}
                  >
                    {property.category === 'sale'
                      ? formatCurrency(property.asking_price, property.currency)
                      : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      ...outfitFontStyle,
                      color: '#6b7280',
                      fontSize: '14px',
                      mb: 2,
                      lineHeight: 1.4,
                    }}
                  >
                    {property.area_name || ""}, {property.location || ""}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pt: 1,
                    borderTop: '1px solid #f3f4f6',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <VisibilityIcon
                      sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        ...outfitFontStyle,
                        color: '#6b7280',
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                    >
                      0 Views
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      ...outfitFontStyle,
                      color: '#9ca3af',
                      fontSize: '11px',
                    }}
                  >
                    Property ID: #PD{property.id.toString().padStart(6, '0')}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>

      {pageCount > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={handleChangePage}
            color="primary"
            size="large"
            sx={{
              '& .MuiPaginationItem-root': {
                ...outfitFontStyle,
                fontWeight: 500,
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default PropertySeeAll;